// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "DraggableTableRow1326524724";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"DraggableTableRow1326524724__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-table-list-item-fill-hover-draggable":"--wds-table-list-item-fill-hover-draggable","wds-table-list-item-fill-overlay":"--wds-table-list-item-fill-overlay","wds-color-border-dark-secondary":"--wds-color-border-dark-secondary"}; 




